// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:57:52

export default {
  "id": "merge-hospital",
  "slug": "merge-hospital",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/34228dc4cd784e43857cc4c678a83984-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/34228dc4cd784e43857cc4c678a83984/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Hospital",
      "description": "Play as Doctor Player in Merge Hospital and discover the many secrets of your staff members, and what is happening in and around the Hospital. In Merge Hospital by Operate Now you will merge and build, meet and love many skilled surgeons, doctors and other interesting characters. You will learn more about their stories and how they got into the hospital.\n\nAs Dr. Player you must:\nMERGE medical items, pies and much more!\nDISCOVER the story of a medical drama like in your favorite TV shows.",
      "instructions": "Merge 2 items that can be merged together. Items are generated through generators. Using a generator will reduce your energy. Once all energy is depleted you need to wait for new energy or replenish it via the shop. Completing tasks will earn you hearts, these hearts are used to progress through the story.",
      "genres": [
        "Merge"
      ],
      "tags": [
        "hospital",
        "medical",
        "mission",
        "story"
      ]
    },
    "zh-CN": {
      "title": "合并医院",
      "description": "扮演玩家医生在合并医院中，揭开你员工们的众多秘密，以及医院内外发生的事情。在Operate Now的合并医院中，你将合并和建设，结识并爱上许多技艺高超的外科医生、医生和其他有趣的角色。你将了解更多关于他们的故事以及他们是如何进入医院的。\n\n作为玩家医生，你必须：\n合并医疗物品、派对和更多！\n发现像你最喜欢的电视剧中的医疗剧一样的故事。",
      "instructions": "合并可合并的2个物品。物品由生成器生成。使用生成器会消耗能量。能量耗尽后，您需要等待能量恢复或通过商店补充。完成任务会获得心形标记，这些心形标记用于推动故事进展。",
      "genres": [
        "合并"
      ],
      "tags": [
        "医院",
        "医疗",
        "任务",
        "故事"
      ]
    },
    "zh-TW": {
      "title": "合併醫院",
      "description": "扮演「玩家醫生」在合併醫院中，揭開員工們的許多秘密，以及醫院內外所發生的事。在「合併醫院」由「運作現在」開發的遊戲中，您將合併與建設，認識並愛上許多技術高超的外科醫生、醫生及其他有趣的角色。您將更了解他們的故事和他們如何進入醫院。\n\n作為「玩家醫生」，您必須：\n合併醫療用品、派對蛋糕等等！\n揭開類似您喜愛的電視劇中的醫療劇情。",
      "instructions": "合併可合併的兩件物品。物品通過生成器生成。使用生成器將會消耗你的能量。一旦能量耗盡，你需要等待新的能量或通過商店補充能量。完成任務將獲得心臟，這些心臟用於進行故事進展。",
      "genres": [
        "合併"
      ],
      "tags": [
        "醫院",
        "醫療",
        "任務",
        "故事"
      ]
    },
    "zh-HK": {
      "title": "合併醫院",
      "description": "扮演Dr. Player於Merge Hospital，揭開員工的各種秘密，以及醫院內外發生的事情。在Operate Now的Merge Hospital中，你將合併並建築，認識並愛上許多技術高超的外科醫生、醫生及其他有趣的角色。你將了解更多他們的故事以及他們如何進入醫院。\n\n作為Dr. Player，你必須：\n合併醫療物品、派對蛋糕等等！\n揭開類似你喜愛的電視劇中的醫療劇情。",
      "instructions": "合併可合併的兩件物品。物品透過生成器產生。使用生成器會消耗你的能量。一旦能量耗盡，你需要等待新能量或透過商店補充。完成任務將獲得心，這些心可用於進度故事。",
      "genres": [
        "合併"
      ],
      "tags": [
        "醫院",
        "醫療",
        "任務",
        "故事"
      ]
    },
    "ja": {
      "title": "合併病院",
      "description": "Merge Hospitalでドクター・プレイヤーとしてプレイし、スタッフの多くの秘密や病院の周辺で起こっていることが分かります。Operate NowのMerge Hospitalで、多くの技術的な外科医、医師他の面白いキャラクターと合体し、出会い、愛します。彼らの物語や病院に入った理由をさらに学びます。\n\nドクター・プレイヤーとして、以下を行わなければなりません：\n\n医療用品、パイなど、さまざまなものを合体させます！\nお気に入りのテレビショーのような医療ドラマの物語を発見します。",
      "instructions": "2つの合流可能なアイテムを合流させます。アイテムはジェネレーターで生成されます。ジェネレーターを使用するとエネルギーが減少します。エネルギーがすべて消耗したら、新しいエネルギーを待つか、ショップでエネルギーを回復させます。タスクを完了するとハートがもらえます。これらのハートは物語を進めるのに使われます。",
      "genres": [
        "合体"
      ],
      "tags": [
        "病院",
        "医療",
        "任務",
        "物語"
      ]
    },
    "ko": {
      "title": "병원 합병",
      "description": "메이지 병원에서 닥터 플레이어로 출연해 직원들의 많은 비밀과 병원 내외에서 일어나는 일을 밝혀보세요. Operate Now의 메이지 병원에서는 합병하고 건설하며 많은 능숙한 수술사, 의사 그리고 흥미로운 캐릭터들을 만나 사랑할 수 있습니다. 그들의 이야기와 병원에 와서까지 어떻게 되었는지 더 알 수 있습니다.\n\n닥터 플레이어로서는 다음과 같이 해야 합니다:\n\n의료 물품, 파이 그리고 많은 것들을 합병하세요!\n귀하의 취향에 맞는 TV 프로그램에서 볼 수 있는 의료 드라마의 이야기를 발견하세요.",
      "instructions": "합성할 수 있는 2개의 아이템을 합성하세요. 아이템은 생성기로 생성됩니다. 생성기를 사용하면 에너지가 줄어듭니다. 모든 에너지가 소진되면 새로운 에너지를 기다려야 하거나 상점에서 에너지를 보충해야 합니다. 작업을 완료하면 하트를 획득하며, 이 하트는 이야기를 진행하는 데 사용됩니다.",
      "genres": [
        "병합"
      ],
      "tags": [
        "병원",
        "의료",
        "임무",
        "이야기"
      ]
    },
    "fr": {
      "title": "Hôpital de Fusion",
      "description": "Jouez en tant que Dr. Player dans Merge Hospital et découvrez les nombreux secrets de vos membres du personnel, ainsi que ce qui se passe à l'intérieur et autour de l'Hôpital. Dans Merge Hospital par Operate Now, vous fusionnerez et construirez, rencontrerez et aimerez de nombreux chirurgiens, médecins et autres personnages intéressants. Vous découvrirez plus sur leurs histoires et comment ils sont arrivés à l'hôpital.\n\nEn tant que Dr. Player, vous devez :\nFUSIONNER des articles médicaux, des gâteaux et bien plus encore !\nDECouVRIR l'histoire d'un drame médical comme dans vos émissions TV préférées.",
      "instructions": "Fusionnez 2 objets qui peuvent être combinés. Les objets sont générés par des générateurs. L'utilisation d'un générateur réduira votre énergie. Une fois que toute l'énergie est épuisée, vous devez attendre la production de nouvelle énergie ou la recharger via la boutique. La complétion des tâches vous rapportera des cœurs, ces cœurs sont utilisés pour avancer dans l'histoire.",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "hôpital",
        "médical",
        "mission",
        "histoire"
      ]
    }
  }
};
